import '../../css/app.css';
import { mountShell } from '../shared/mountShell';
import { createRoot } from 'react-dom/client';
if (document.getElementById('suac-member-core')) {
    void import('../member-core/CoreApp').then(({ CoreApp }) => {
        const root = document.getElementById('suac-member-core');
        if (root) createRoot(root).render(<CoreApp />);
    });
} else if (document.getElementById('suac-membership')) {
    void import('../membership/Membership').then(({ Membership }) => {
        const root = document.getElementById('suac-membership');
        if (root) createRoot(root).render(<Membership />);
    });
} else {
    mountShell('member');
}
